/* global jQuery, js_vars, elementorFrontend, Mmenu */
const theme_url = ('themeurl' in js_vars) ? js_vars.themeurl : '';

/*--------------------------------------------------------------------------------
General Ready
--------------------------------------------------------------------------------*/
( function( $ ) {
$(document).ready(function() {
	
	const siteWidth = 1320,
	mobileWidth = 768;

	/*--------------------------------------------------------------------------------
	Utility: Add class on window height
	--------------------------------------------------------------------------------*/
	
	function windowResize() {
		let windowHeight = $(window).height();
		if( windowHeight < 940 ) {
			$('body').addClass('bodyheight-short');
		} else {
			$('body').removeClass('bodyheight-short');
		}
	}

	windowResize();
	$(window).resize(function(){ windowResize(); });


	/*--------------------------------------------------------------------------------
	Utility: Hide element on click outside
	--------------------------------------------------------------------------------*/
	
	function hideOnClickOutside( selector, type = 'standard' ) {
		const outsideClickListener = (event) => {
			const $target = $(event.target);
			if ( ! $target.closest(selector).length ) {
				$(selector).removeClass('open');
				removeClickListener();
			}
		}

		const removeClickListener = () => {
			document.removeEventListener('click', outsideClickListener)
		}
		
		document.addEventListener('click', outsideClickListener)
	}


	/*--------------------------------------------------------------------------------
	Add processing class to long-response and error-prone buttons
	--------------------------------------------------------------------------------*/
	
	// Add to Autoship deletion
	$( '.autoship-action-btn.deleted' ).click(function(e) {
		$(this).addClass('processing');
	});

	// Remove from Autoship deletion on cancel
	$( document ).on('click', '.autoship-order-notice .cancel-action', function(){
		$( '.autoship-action-btn.deleted' ).removeClass('processing');
	});

	$( document ).on('click', '.restore-item, .confirm-action, .product-remove a', function(){
		$(this).addClass('processing');
	});


	/*--------------------------------------------------------------------------------
	Forms
	--------------------------------------------------------------------------------*/

	/**
	* Larger select dropdowns via radios
	*/
	$( '.radio-dropdown' ).click( function(e) {
		let $this = $(this);
		$this.toggleClass( 'open' );
		hideOnClickOutside( $this );
	});

	// Reset radio buttons on load
	$('.radio-dropdown input[type="radio"]').prop('checked', false);

	// Watch for radio changes
	$( document ).on( 'change', '.radio-dropdown input[type="radio"]', function(e) {
		let $this = $( e.target ).first();
		let $parent = $this.parents('.radio-dropdown').first();
		let selectedOption = $this.siblings('label').html();
		
		// Close menu, swap in selected option
		$parent.removeClass( 'open' );
		$parent.find('.radio-dropdown__current').first().html( selectedOption );
	});


	/*--------------------------------------------------------------------------------
	Woocommerce
	--------------------------------------------------------------------------------*/

	/**
	* Enable Smooth Scrolling for YWAR total reviews anchor, and "Leave a Review" CTA
	*/

	const reviewFormScroll = () => {
		let reviewFormContainer = $('.yith-ywar-edit-forms');
		if(reviewFormContainer) {
		$( 'html, body' )
			.animate(
				{
					scrollTop: reviewFormContainer.offset().top - 50
				},
				500
			);
		}
	}
	let reviewCtaAnchor = $('.review-scroll');
	if(reviewCtaAnchor) reviewCtaAnchor.click(reviewFormScroll);

	const reviewScroll = () => {
		let reviewContainer = $('.product__review');
		if(reviewContainer) {
		$( 'html, body' )
			.animate(
				{
					scrollTop: reviewContainer.offset().top - 50
				},
				500
			);
		}
	}
	let yithTotalReviewAnchor = $('.total-reviews');
	if(yithTotalReviewAnchor) yithTotalReviewAnchor.click(reviewScroll);
	
	/**
	* Conditionally disable add to cart, quantity, and autoship form when no variation is selected
	*/
	$( '.variations_form' ).on( 'hide_variation', function (e, data) {
		$(this).find('.quantity-container').addClass('disabled');
		$('.autoship-schedule-options-variable').addClass('disabled');
		$( '.product-type-variable .onsale' ).css( 'display', 'none' );

		$('.product__summary > .price').html( $('.product__pricingarray').html() );
	});

	/**
	* Update Single Product details when a variation is selected
	*/
	$( '.variations_form' ).on( 'show_variation', function (e, data) {
		// Enable add to cart & quantity sections
		$(this).find('.quantity-container').removeClass('disabled');
		$('.autoship-schedule-options-variable').removeClass('disabled');

		// Update main price field with variation's price
		$('.product__summary > .price').empty();
		$('.product__summary > .price').html( $('.woocommerce-variation-price .price').html() );

		// Check current variation stock status, update or hide quantity input
		let maxQty = data.max_qty;
		let inStock = data.is_in_stock;
		let $quantityInput = $('.product__summary .qty');
		if( inStock === false && data.backorders_allowed === false ) {
			// Product is out of stock
			$(this).addClass('outofstock');
			$quantityInput.parents('.quantity-container').hide();
		} else {
			$(this).removeClass('outofstock');
			$quantityInput.parents('.quantity-container').show();

			// Set maximum available on quantity input, if necessary
			if( Number.isInteger(maxQty) && inStock ) {
				$quantityInput.attr("max", maxQty);
			} else {
				$quantityInput.attr("max", "");
			}
		}

		// Prep variation meta updates
		let $product_meta_content = $('#product_meta_content');
		let content = '';

		// Update number of servings
		let number_servings = $('.woocommerce-variation-number_servings').html();
		if( number_servings ) {
			content += `<div class="servings_wrapper">
				<span class="servings">
					Servings: ${number_servings}
				</span>
			</div>`;
		}

		// Update SKU
		let variation_sku = data.sku;
		if( variation_sku ) {
			content += `<div class="sku_wrapper">
				SKU: 
				<span class="sku">
					${variation_sku}
				</span>
			</div>`;
		}

		// Update UPC
		let variation_upc = data.upc;
		if(variation_upc) {
			content += `<div class="upc_wrapper">
				UPC:
				<span class="upc">
					${variation_upc}
				</span>
			</div>`;
		}
		
		$product_meta_content.html(content);
	});

	/**
	* Conditionally show/hide the sale badge for a variation when changed
	*/
	$( 'form.variations_form' ).on( 'show_variation', function( event, data ) {
		if( data.display_price < data.display_regular_price ) {
			$( '.product-type-variable .onsale' ).css( 'display', 'block' );
			$( '.price .price-label' ).css( 'text-decoration', 'line-through' );
		} else {
			$( '.product-type-variable .onsale' ).css( 'display', 'none' );
			$( '.price .price-label' ).css( 'text-decoration', 'none' );
		}
	});

	/**
	* Update cart when subscription type or quantity is changed
	*/
	let qtyTimeout = false;
	$(document).on( 'change', 'input.qty, .woocommerce-cart-form .autoship-type input[type="radio"]', function() {
		if ( qtyTimeout ) { clearTimeout( qtyTimeout ); }

		qtyTimeout = setTimeout( function() {
			$('button[name="update_cart"]').trigger('click');
		}, 750 );
	});

	$(document).on( 'keyup', 'input.qty', function() {
		if ( qtyTimeout ) { clearTimeout( qtyTimeout ); }

		qtyTimeout = setTimeout( function() {
			$('button[name="update_cart"]').trigger('click');
		}, 750 );
	});

	/**
	* Quantity plus and minus buttons
	*/
	$( document ).on( 'click', '.quantity-minus, .quantity-plus', function() {
		let $this = $(this),
		qty = $this.parents( '.quantity-container' ).find( '.qty' ),
		val = parseFloat( qty.val() ),
		max = parseFloat( qty.attr('max') ),
		min = parseFloat( qty.attr('min') ),
		step = parseFloat( qty.attr('step') );

		if ( $this.is('.plus') ) {
			if ( max && ( max <= val ) ) {
				qty.val( max );
			} else {
				qty.val( val + step );
			}
		} else {
			if ( min && ( min >= val ) ) {
				qty.val( min );
			} else if ( val > 1 ) {
				qty.val( val - step );
			}
		}

		qty.trigger('change');
	});

	/**
	* Hide "add to wishlist" button when no variation is selected
	*/
	$( '.variations_form' ).on( 'woocommerce_variation_select_change', function() {
		if( $('#pa_sizes').val() == '' ) {
			$('.yith-wcwl-add-to-wishlist').addClass('hidden');
		} else {
			$('.yith-wcwl-add-to-wishlist').removeClass('hidden');
		}
	});

	/**
	* Prevent triggering multiple AJAX product additions when "add to cart" button is rapidly clicked
	*/
	$( document.body ).on( 'adding_to_cart', function(e) {
		$( '.single_add_to_cart_button' ).prop( "disabled", true );
	});

	$(document.body).on('added_to_cart',function(e){
		$( '.single_add_to_cart_button' ).prop( "disabled", false );
	});

	/**
	* Refresh cart page when emptied so that Elementor empty cart template can display
	*/
	$( document.body ).on( 'wc_cart_emptied', function() {
		$( window ).scrollTop(0);
		window.location.reload();
	});

	/**
	* Remove YITH Wishlist add to cart button when clicked to prevent adding more than stock allows
	*/
	$( document.body ).on( 'click', '.wishlist-items-wrapper .product-add-to-cart', function() {
		$(this).find('.add_to_cart_button').remove();
	});


	/*--------------------------------------------------------------------------------
	Autoship
	--------------------------------------------------------------------------------*/

	/**
	* Manage "add to existing subscription" functionality
	*/

	// Watch for variation form changes
	$( 'form.variations_form' ).on( 'show_variation', function( event, data ) {
		if( $('#add_to_autoship_builder .radio-dropdown__body').children().length == 0 ) {
			$('.autoship-existing').css('display', 'none');
		} else {
			// Update URL builder with current variation ID
			$('#add_to_autoship_builder').attr('data-variationid', data.variation_id);

			// Rebuild URL
			autoship_build_url();
		}
	});

	// Rebuild URL on autoship schedule and quantity changes
	$( 'input[name="autoship_order"], .quantity input[name="quantity"]' ).on( 'change', function() {
		autoship_build_url();
	});

	// Conditionally display "add to cart" and "add to subscription" buttons and make sure frequency doesn't appear when it shouldn't
	$( '.autoship-schedule-options .autoship-type input[type="radio"]' ).on( 'change', function(e) {
		if( $(e.target ).val() == 'existing' ) {
			// Make sure autoship frequency dropdown is hidden
			$( '.autoship-frequency' ).removeClass('active');

			// Show "add to existing subscription" button, hide "add to cart" button
			$( '.add_to_cart_button_container' ).addClass('hidden');
			$( '.autoship-add-button' ).addClass('active');
			$( '#add_to_autoship_builder' ).addClass('active');

		} else {
			$( '.add_to_cart_button_container' ).removeClass('hidden');
			$( '.autoship-add-button' ).removeClass('active');
			$( '#add_to_autoship_builder' ).removeClass('active');
		}
	});

	// Build an "add to existing subscription" URL based on selected product, variation, and qty
	function autoship_build_url() {
		let builder = $('#add_to_autoship_builder');
		if( builder ) {
			let selected_order = $('input[name="autoship_order"]:checked').val();
			if( selected_order ) {
				let product_id = false;
				let product_type = builder.data('producttype');
				if( product_type == 'variable' ) {
					product_id = builder.attr('data-variationid');
				} else {
					product_id = builder.data('productid');
				}
				
				if( product_id ) {
					let quantity = $('.quantity input[name="quantity"]').val();
					console.log(quantity);
					if( !quantity || quantity < 1 ) quantity = 1;

					let baseurl = builder.data('baseurl');
					let options = '&item=' + product_id + '&order=' + selected_order + '&qty=' + quantity;

					let finalurl = baseurl + options;

					$('#add_to_autoship_url').html(finalurl);
					$('#autoship-add-button').attr( 'href', finalurl ).text('Add to Existing Subscription').removeClass('disabled');
				}
			}
		}
	}	


	/*--------------------------------------------------------------------------------
	Tooltips
	--------------------------------------------------------------------------------*/

	$(document).on( 'mouseover mouseleave click', '.stallop-tooltip', function(e) {
		let $this = $(this);
		if( e.type === 'mouseover' || e.type === 'click' ) {
			let tooltipText = $this.data('tooltip');
			$this.append('<div class="tooltip__content"><span class="tooltip__text">' + tooltipText + '</span></div>');
		} else {
			$this.find('.tooltip__content').remove();
		}
	});


	/*--------------------------------------------------------------------------------
	Desktop Megamenu
	--------------------------------------------------------------------------------*/

	let hideMenu = false;
	let menuOpen = false;
	let currentMenu;

	/*
	* Handle mouse interaction for navigation components
	*/
	$('#site-header__lower').mouseleave(function(){
		hideMenu = setTimeout( function() {
			_do_hide_menu();
		}, 350 );
	});

	$('#site-header__lower').mouseenter(function(){
		if( hideMenu ) {
			clearTimeout( hideMenu );
		}
	});

	$(document).on( 'click', '#site-header__navigation', function(e) {
		if( $(e.target).hasClass('hw-menuentry--megamenu') && menuOpen == false ) {
			_do_show_menu(e);
		} else {
			_do_hide_menu();
		}
	});

	/*
	* hoverIntent.js only handles mouseIn
	* mouseOut is managed with hideMenu to allow
	* for more time before the menu disappears
	*/
	$('.hw-menuentry').hoverIntent({
		over: _do_show_menu,
		interval: 50
	});

	/*
	* Manage menu open and close
	*/
	function _do_hide_menu() {
		let $container = $('#site-header__megamenu');
		$container.removeClass('open');
		$('.hw-menuentry--megamenu').removeClass('active');
		menuOpen = false;
	}

	function _do_show_menu(e) {
		let $this = $(e.target);
		if( ! $this.hasClass('hw-menuentry') ) {
			$this = $(e.target).parents('.hw-menuentry');
		}

		if( $this.hasClass('hw-menuentry--megamenu') ) {
			let $submenu = $this.find('.hw-submenu');
			let submenuNumber = $submenu.data('submenu');

			if( currentMenu !== submenuNumber || menuOpen == false ) {
				let $container = $('#site-header__megamenu');
				let $body = $('.site-header__megamenu-body');
				let $content = $('#site-header__megamenu-content');

				// Column setup
				let columnCount = $submenu.find('.submenu-column').length;
				let columnWidth = 320;

				// Stop all animations
				$content.stop();
				$container.stop();
				
				// Prep new active menu entry, fade out current menu entry content
				$('.hw-menuentry--megamenu').removeClass('active').filter($this).addClass('active');
				
				$content.fadeOut( 80, function() {

					// Display new submenu content
					$content.empty().append($submenu.clone().show());
					$content.fadeIn(250);

					if( menuOpen == false ) {
						$container.addClass('open');
						menuOpen = true;
					}

					// Prep submenu and arrow positioning
					let containerWidth = $('#site-header__navigation').width();
					let containerPadding = $('#site-header__navigation').outerWidth() - containerWidth;
					let entryPosition = $this.position();
					let menuEntryWidth = $this.width() / 2;
					let menuWidth = "100%";
					let menuLeft = 0;

					// Check column count, adjust submenu size and positioning
					if( columnCount < 4 ) {
						menuWidth = columnCount * columnWidth;

						// Check for container blowouts before and after positioning
						if( menuWidth > containerWidth ) {
							menuLeft = 0;
							menuWidth = "100%";
						} else {
							if( ( entryPosition.left + menuWidth ) > containerWidth ) {
								let difference = (entryPosition.left + menuWidth ) - containerWidth;
								menuLeft = entryPosition.left - difference;
							} else {
								menuLeft = entryPosition.left - 60;
							}
						}
					}

					// Resize and position submenu
					$body.css("left", Math.max(0, menuLeft));
					$body.css("width", menuWidth);

					// Move arrow into place
					$('#site-header__megamenu-arrow').css("left", entryPosition.left - containerPadding + menuEntryWidth );

					// Adjust container height to fit new submenu
					$body.animate({
						height: $submenu.outerHeight()
						}, "fast", function() {
							// Track current submenu
							currentMenu = submenuNumber;
						}
					);
				});
			}

		} else {
			// Hide megamenu if hovering on a non-megamenu item
			_do_hide_menu();
		}
	}

} );
} )( jQuery );


/*--------------------------------------------------------------------------------
Mobile Menu
--------------------------------------------------------------------------------*/
document.addEventListener(
	"DOMContentLoaded", () => {

		jQuery(document).on( 'click', '.search-icon', function() {
			let $this = jQuery(this);
			let $input = $this.siblings('input[name="s"]');
			
			if( $input.val() !== '' ) {
				$this.parents('form').submit();
			}
		});

		const nav_actions = jQuery('.navigation-actions').clone();

		let mobileMenu = document.getElementById("mobile-menu");
		let mobileMenuMmenu = false;

		if( mobileMenu ) {
			mobileMenuMmenu = new Mmenu( "#mobile-menu", {
				"offCanvas": {
					"clone": "true",
					"position": "right"
				},
				"theme": "light",
				"navbars": [
					{
						"position": "top",
						"content": [
							"<div class='mobile-menu__logo-container'><img class='mobile-menu__logo' src='" + theme_url + "/assets/images/logo.svg' alt='Stallop' /></div>",
							"close"
						]
					},
					{
						"position": "top",
						"content": [
							"<div id='navigation-actions--mobile' class='navigation-actions--mobile'></div>"
						]
					},
					{
						"position": "top",
						"content": [
							"prev",
							"title"
						]
					}
				],
				hooks: {
					"openPanel:before": ( panel ) => {
						let nav_top = document.getElementById("mobile-menu");
						jQuery('#navigation-actions--mobile').html(nav_actions);

						if( panel.id == 'mm-1' ) {
							nav_top.classList.add("mm-home");
							jQuery(nav_top).find('.mm-navbar__title').parent('.mm-navbar').addClass('menu-hidden');
						} else {
							nav_top.classList.remove("mm-home");
							jQuery(nav_top).find('.mm-navbar__title').parent('.mm-navbar').removeClass('menu-hidden');
						}
					}
				}
			});
		}

		function windowResizeMmenu() {
			let windowWidth = jQuery(window).width();
			if( windowWidth > 1080 && mobileMenuMmenu ) {
				mobileMenuMmenu.close();
			}
		}
	
		jQuery(window).resize(function(){ windowResizeMmenu(); });
	}
);